import React, { useContext } from 'react';
import SelectSmall from '../../../general-components/select-small';
import PreviewButton from '../../preview-button';
import DirectionalSelection from './directional-selection';
import AnimationDuration from './animation-duration';
import AnimationSectionHeader from './animation-section-header';
import { ICONS } from '../../../general-components/icon';
import AnimationRangeInput from './animation-range-input';
import { AnimationsContext } from './animations-context';
import * as T from './types';

interface Props {
	isForShotEditorModal?: Boolean;
	stylepackItem?: Boolean;
}

export default function AnimationsTab(props: Props) {

	const {
		selectedInAnimation,
		setSelectedInAnimation,
		selectedOutAnimation,
		setSelectedOutAnimation,
		handleInOutDurationChange,
		selectedOutDuration,
		selectedInDuration
	} = useContext(AnimationsContext);

	if (props.stylepackItem) {
		return <div className="settings-container animation-container position-relative">
			<AnimationDuration isStylepack={true} />
		</div>
	}

	return (
		<div className="settings-container animation-container position-relative">
			<AnimationDuration isStylepack={false}/>
			<hr/>
			<AnimationSectionHeader
				text='Build in'
				icon={ICONS.ANIMATION_IN}
				rightWidget={<PreviewButton isOut={false}/>}
			/>
			<div className="animation-row">
				<span className='bl-font-p2'>Effect</span>
				<SelectSmall
					options={T.animationOptions}
					label={selectedInAnimation?.label || T.animationOptions[0].label}
					selected={selectedInAnimation || T.animationOptions[0]}
					dropdown
					dropdownPosition="drop-left"
					className='animation-dropdown-selection'
					onChange={(e) => {
						setSelectedInAnimation(
							T.animationOptions.find((ao) => ao && ao.value === e) || T.animationOptions[0],
						);
					}}
				/>
			</div>
			<AnimationRangeInput
				value={selectedInDuration?.value || T.durationOptions[0]}
				onChange={(e) => handleInOutDurationChange(e.valueOf(), false)}
				min={0.25}
				max={10}
				step={0.25}
				snap={true}
				ticks={[
					{ label: '.25s', position: 'left' },
					{ label: '.5s', position: 'center' },
					{ label: '1s', position: 'center' },
					{ label: '5s', position: 'center' },
					{ label: '10s', position: 'right' },
				]}
			/>
			<DirectionalSelection isOut={false}/>
			<hr/>
			<AnimationSectionHeader
				text='Build out'
				icon={ICONS.ANIMATION_OUT}
				rightWidget={<PreviewButton isOut={true}/>}
			/>
			<div className="animation-row">
				<span className='bl-font-p2'>Effect</span>
				<SelectSmall
					options={T.animationOutOptions}
					label={selectedOutAnimation?.label || T.animationOutOptions[0].label}
					selected={selectedOutAnimation || T.animationOutOptions[0]}
					dropdown
					dropdownPosition="drop-left"
					className='animation-dropdown-selection'
					onChange={(e) => {
						setSelectedOutAnimation(
							T.animationOutOptions.find((ao) => ao?.value === e) || T.animationOutOptions[0],
						);
					}}
				/>
			</div>
			<AnimationRangeInput
				value={selectedOutDuration?.value || T.durationOptions[0]}
				onChange={(e) => handleInOutDurationChange(e.valueOf(), true)}
				min={0.25}
				max={10}
				step={0.25}
				snap={true}
				ticks={[
					{ label: '.25s', position: 'left' },
					{ label: '.5s', position: 'center' },
					{ label: '1s', position: 'center' },
					{ label: '5s', position: 'center' },
					{ label: '10s', position: 'right' },
				]}
			/>
			<DirectionalSelection isOut={true}/>
		</div>
	);
}
